import styled from 'styled-components';
import {Space} from 'antd';
import {bordersStyles} from '../../utils/styles';

const TABS_WIDTH = '384px';

const StyledBudgetsRequestPageContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 24px;
  & > div {
    &:nth-of-type(1) {
      width: calc(100% - ${TABS_WIDTH} - 24px);
    }
    &:nth-of-type(2) {
      width: ${TABS_WIDTH};
    }
  }
`;

const StyledBudgetsRequestPageContent = styled(Space)`
  ${bordersStyles.light};
  background-color: ${props => props.theme.colors.neutral_1};

  border-radius: 4px;
  padding: 24px;
`;

export {
  StyledBudgetsRequestPageContainer,
  StyledBudgetsRequestPageContent,
}
